import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { ButtonsModule } from '@components/buttons/buttons.module';
import { ModalComponent } from './modal.component';
@NgModule({
  imports: [CommonModule, MatDialogModule, ButtonsModule],
  exports: [ModalComponent],
  declarations: [ModalComponent],
})
export class ModalModule {}
